/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/flowers-gpt';
const RESOURCE_PAGE_CARTSERVICE = 'gift-message';

const getChatgptMessage = ({
    env, jwtToken, payload,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}`;

    const resourcePage = `/api/${RESOURCE_PAGE_CARTSERVICE}`;

    return restClient.getRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default getChatgptMessage;

// /*
//  * Confidential and Proprietary.
//  * Do not distribute without 1-800-Flowers.com, Inc. consent.
//  * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
//  */

// import restClient from './restClient';

// const RESOURCE_ROOT_CARTSERVICE = '/checkout';
// const RESOURCE_VERSION_CARTSERVICE = '/v2';
// const RESOURCE_PAGE_CARTSERVICE = '/cart';

// /**
//  * getCart
//  * url - /checkout/{apiversion}/cart/{cartId}?brand={brandId}
//  *
//  * @param {Object} args
//  * @param {String} args.env
//  * @param {String} args.jwtToken
//  * @param {String} args.cartId
//  */
// const getCart = ({ env, jwtToken, occasion, relation, recipientName, tone, characterLimit, userId,}) => {
//     const envObj = env || {};

//     envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

//     const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}/${cartId}`;

//     return restClient.getRequest(envObj, resourcePage, jwtToken)
//         .then((response) => response);
// };

// export default getCart;
